import { Cross2Icon, Crosshair1Icon } from '@radix-ui/react-icons';
import { Flex, Text } from '@radix-ui/themes';
import { SmallFilledCircleIcon } from 'components/common/custom-icon/shorthands';

export const PitchPerfPlotHwdLegend = () => {
  return (
    <Flex
      gap="3"
      align="center"
      style={{
        color: 'var(--gray-10)',
      }}
    >
      <Flex gap="1" align="center">
        <SmallFilledCircleIcon />
        <Text>Diagnostic Shots</Text>
      </Flex>

      <Flex gap="1" align="center">
        <Cross2Icon />
        <Text>Repeatability Shots</Text>
      </Flex>

      <Flex gap="1" align="center">
        <Crosshair1Icon />
        <Text>Target Values</Text>
      </Flex>
    </Flex>
  );
};
